import { FailReason, Step } from '@repo/common';
import { useCallback } from 'react';

import { setCustomerDataAction, setWorkflowAction } from '@/providers/app-provider/actions';
import { useAppContext } from '@/providers/app-provider/context';
import { selectStep } from '@/providers/app-provider/selectors';
import { postSubmitHandled } from '@/services/rivaas-api';
import { stepToWorkflow } from '@/utils/step-workflow';

export function useCancelVerification() {
  const { dispatch, state } = useAppContext();

  const step = selectStep(state);
  const unverifiedUrl = state.customerData?.redirect?.unverifiedUrl;

  return useCallback(
    async (useWorkflow: boolean = true) => {
      if (useWorkflow) {
        // BFF cleanup: delete DIS customer + session. The response code is irrelevant for UI
        // decisions — an explicit cancel always shows UNABLE_TO_VERIFY, never NOT_FOUND.
        await postSubmitHandled(undefined, {
          cancel: true,
          clearRedirectToken: step?.value === Step.MOBILE_REDIRECT,
        });

        const workflowBase = stepToWorkflow('fail', {
          unverifiedUrl,
          verifiedUrl: state.customerData?.redirect?.verifiedUrl,
        });

        if (workflowBase) {
          dispatch(
            setWorkflowAction({
              ...workflowBase,
              nextStep: {
                ...workflowBase.nextStep,
                failReason: FailReason.UNABLE_TO_VERIFY,
              },
            }),
          );
          // Clear firstStep so the retry button is not shown — user chose to cancel.
          if (state.customerData) {
            dispatch(setCustomerDataAction({ ...state.customerData, firstStep: undefined }));
          }
        }
      } else {
        dispatch(
          setWorkflowAction({
            context: {},
            nextStep: {
              value: Step.FAIL,
              failReason: FailReason.UNABLE_TO_VERIFY,
              action: {
                type: 'REDIRECT',
                data: {
                  url: unverifiedUrl ?? 'http://localhost:3000/result',
                  payload: {
                    result: 'error',
                  },
                },
              },
            },
          }),
        );
      }
    },
    [dispatch, state.customerData, step?.value, unverifiedUrl],
  );
}
